module.exports = __webpack_public_path__ + "assets/img/xiaohongshu.7e4bd5e5.png";